const publicAuthActionPaths = new Set([
  '/',
  '/preview',
  '/features',
  '/use-cases',
  '/guides',
  '/plans',
  '/cookie-policy',
  '/cookie-policy.html',
  '/privacy-policy',
  '/privacy-policy.html',
  '/terms-of-service',
  '/terms-of-service.html',
  '/acceptable-use-policy',
  '/acceptable-use-policy.html',
  '/privacy-requests',
]);

const standalonePublicDocumentPaths = new Set([
  '/pocket-phrasebook/privacy',
  '/pocket-phrasebook/support',
]);

export const shouldShowPublicAuthActions = (
  activePath: string,
  isEntryAuthFlow: boolean,
): boolean => {
  if (isEntryAuthFlow) return false;
  if (activePath.startsWith('/use-cases/')) return true;
  if (activePath.startsWith('/guides/')) return true;
  return publicAuthActionPaths.has(activePath);
};

export const isPublicNavLinkActive = (activePath: string, targetPath: string): boolean =>
  activePath === targetPath || activePath.startsWith(`${targetPath}/`);

export const shouldUseStandalonePublicDocument = (activePath: string): boolean =>
  standalonePublicDocumentPaths.has(activePath);
